import { all } from 'redux-saga/effects'
import { routerWatcher } from './router'
import { authWatcher } from './auth'
import { groupsWatcher } from './groups'
import { analyticsWatcher } from './analytics'
import { groupsDetailedWatcher } from './groupsDetailed'
import { groupWatcher } from './group'
import { editorsPerGroupWatcher } from './editorsPerGroup'
import { notificationsWatcher } from './notifications'
import { packWatcher } from './pack'
import { fileWatcher } from './file'
import { datafileWatcher } from './datafile'
import { datachartWatcher } from './datachart'
import { configWatcher } from './config'
import { searchWatcher } from './search'
import { publishedSearchWatcher } from './publishedSearch'
import { mediaTypeWatcher } from './mediaType'
import { mediaTypesWatcher } from './mediaTypes'
import { mediaTypeGroupWatcher } from './mediaTypeGroup'
import { mediaTypeGroupsWatcher } from './mediaTypeGroups'
import { capabilitiesWatcher } from './capabilities'
import { publishingLocationsWatcher } from './publishingLocations'
import { capabilityWatcher } from './capability'
import { languagesWatcher } from './languages'
import { publishedGraphicWatcher } from './publishedGraphic'
import { pollingWatcher } from './polling'
import { capabilitiesSummaryWatcher } from './capabilitiesSummary'
import { userPreferencesWatcher } from './userPreferences'

export function* rootSaga() {
  yield all([
    analyticsWatcher(),
    routerWatcher(),
    authWatcher(),
    groupsWatcher(),
    groupsDetailedWatcher(),
    groupWatcher(),
    editorsPerGroupWatcher(),
    notificationsWatcher(),
    packWatcher(),
    fileWatcher(),
    datafileWatcher(),
    datachartWatcher(),
    configWatcher(),
    searchWatcher(),
    publishedSearchWatcher(),
    mediaTypeWatcher(),
    mediaTypesWatcher(),
    mediaTypeGroupWatcher(),
    mediaTypeGroupsWatcher(),
    capabilityWatcher(),
    capabilitiesWatcher(),
    publishingLocationsWatcher(),
    languagesWatcher(),
    publishedGraphicWatcher(),
    pollingWatcher(),
    capabilitiesSummaryWatcher(),
    userPreferencesWatcher(),
  ])
}
